var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconedit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.545,
    height: 13.815,
    viewBox: "0 0 15.545 13.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-edit",
    "data-name": "Icon awesome-edit",
    d: "M10.865,2.25,13.3,4.684a.264.264,0,0,1,0,.372L7.405,10.951l-2.5.278a.525.525,0,0,1-.58-.58l.278-2.5L10.493,2.25A.264.264,0,0,1,10.865,2.25Zm4.372-.618L13.92.315a1.056,1.056,0,0,0-1.49,0l-.955.955a.264.264,0,0,0,0,.372L13.91,4.077a.264.264,0,0,0,.372,0l.955-.955A1.056,1.056,0,0,0,15.237,1.632ZM10.363,9.348v2.747H1.727V3.459h6.2a.332.332,0,0,0,.229-.094l1.08-1.08a.324.324,0,0,0-.229-.553H1.3A1.3,1.3,0,0,0,0,3.027v9.5a1.3,1.3,0,0,0,1.3,1.3h9.5a1.3,1.3,0,0,0,1.3-1.3V8.268a.324.324,0,0,0-.553-.229l-1.08,1.08A.332.332,0,0,0,10.363,9.348Z",
    transform: "translate(0 -0.007)",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconedit);
export default __webpack_public_path__ + "static/media/Iconedit.e080cb68e843cdb0bc9c218f60ff0ad1.svg";
export { ForwardRef as ReactComponent };